import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from "vue";

import { useTranslate } from "@/composables";
import { useCreatorShopRecentProducts } from "@/composables/creator-shop";
import { EXPERIMENTS_CREATOR_GIFT_GUIDES } from "@/utils/experiments/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatorShopProductsTab',
  props: {
  profileId: { type: String, required: true },
  displayName: { type: String, required: true },
  isVisible: { type: Boolean, required: true, default: false },
  hasProductsSets: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;



const { t } = useTranslate();

const { searchTerm, showLoading, showError, productIds, onFetchProducts, onFetchMoreProducts } =
  useCreatorShopRecentProducts(props.profileId);

const isSearch = computed(() => !!searchTerm.value);
const productsFeedTitle = computed(() => {
  if (searchTerm.value) {
    return t("Matching products").value;
  }
  return t("Recent products").value;
});

watch(
  () => props.isVisible,
  (isVisible) => {
    if (isVisible) {
      onFetchProducts(searchTerm.value || "");
    }
  },
  { immediate: true },
);

return { __sfc: true,props, t, searchTerm, showLoading, showError, productIds, onFetchProducts, onFetchMoreProducts, isSearch, productsFeedTitle, EXPERIMENTS_CREATOR_GIFT_GUIDES }
}

})